import { createWebHashHistory, createRouter } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Main",
    component: () => import("@/views/Main/index.vue"),
  },
  {
    path: "/antiquity",
    name: "Antiquity",
    component: () => import("@/views/Antiquity/index.vue"),
  },
  {
    path: "/antiquity/:id",
    name: "AntiquityId",
    component: () => import("@/views/Antiquity/Id/index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login/index.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/Register/index.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: () => import("@/views/Gallery/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/gallery/:galleryId",
    name: "GalleryId",
    component: () => import("@/views/Gallery/Id/index.vue"),
  },
  {
    path: "/album",
    name: "Album",
    component: () => import("@/views/Album/index.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/album/:id",
    name: "AlbumId",
    component: () => import("@/views/Album/Id/index.vue"),
    meta: {
      authRequired: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["isAuthenticated"];

  if (
    to.matched.some(function (routeInfo) {
      if (
        Object.prototype.hasOwnProperty.call(routeInfo.meta, "authRequired")
      ) {
        return routeInfo.meta.authRequired;
      } else {
        return false;
      }
    })
  ) {
    if (isAuthenticated) {
      next();
    } else {
      if (to.params?.relicId) {
        store.commit("saveRelicId", to.params.relicId);
      }
      store.commit("saveNextRoute", to.name);
      next({
        name: "Login",
      });
    }
  } else {
    if (Object.prototype.hasOwnProperty.call(to.meta, "authRequired")) {
      if (!to.meta.authRequired && !isAuthenticated) {
        next();                  
      } else {
        if ( to.name != 'Login' && to.name != 'Register' ) {
          next();          
        } else {
          next({
            name: "Main",
          });
        }
      }
    } else {
      next();
    }
  }
});

export default router;
